import HeroCarousel from './heroCarousel';

export default HeroCarousel;
